import { render, staticRenderFns } from "./respond-to-employer.vue?vue&type=template&id=0535f0da&scoped=true"
import script from "./respond-to-employer.vue?vue&type=script&lang=js"
export * from "./respond-to-employer.vue?vue&type=script&lang=js"
import style0 from "./respond-to-employer.vue?vue&type=style&index=0&id=0535f0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535f0da",
  null
  
)

export default component.exports